/**
 * Controlla se l'elemento passato è un un array
 * @param array
 * @returns {boolean}
 */
export const isArray = (array: any): boolean => (
	typeof array !== "undefined"
	&& array !== undefined
	&& !!array
	&& array !== null
	&& array instanceof Array
);


/**
 * Controlla se l'elemento passato è un un array pieno
 * @param array
 * @returns {boolean}
 */
export const isNotEmptyArray = (array: any[]): boolean => ( !!array && array instanceof Array && array.length > 0 );

export const onlyNotNull = (x: any) => !!x;

export const onlyFirst = (x: any, i: number) => (i === 0);

// export const pop = (item, index, list) => index < (list.length -1);
// export const decapitate = (item, index) => index > 0;

export const getLastElementOr = (final: any, current: any): any => current;
